"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _$previous = babelHelpers.interopRequireDefault(require("$previous"));

var _decorators = require("decorators");

var Card =
/*#__PURE__*/
function (_BaseCard) {
  babelHelpers.inherits(Card, _BaseCard);

  function Card() {
    babelHelpers.classCallCheck(this, Card);
    return babelHelpers.possibleConstructorReturn(this, babelHelpers.getPrototypeOf(Card).apply(this, arguments));
  }

  return Card;
}(_$previous.default);

exports.default = Card;